/**
 * Plugin that subscribes to the `slideAttributes/updateAttributes` mutation and drops the affected
 * slide's entry from the html-slide markup cache (business-logic/html-slide/cache).
 *
 * That module memoises each `html` slide's sanitised markup for the whole session so slide switches
 * are an instant local swap. Without this purge, a live / re-import edit to an html slide — arriving
 * over live sync (MQTT kvSync) from another client, or a local write — would leave the stale markup
 * cached and keep rendering pre-change content for the rest of the session. Mirrors
 * slide-attributes.cache-purge.plugin.js, which purges the sibling attribute cache on the same
 * mutation.
 */
import { purgeSlideHtml } from '@/business-logic/html-slide'

const htmlSlideCachePurgePlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type !== 'slideAttributes/updateAttributes') return

    const slideId = mutation.payload?.slideId
    if (slideId == null) return

    purgeSlideHtml(slideId)
  })
}

export default htmlSlideCachePurgePlugin
